module.exports = __webpack_public_path__ + "static/ebi-c58f57fd5cab917df4bda758365c7dc0.png";